const DocumentService = ( function() {

    function _convertToBlob(data, contentType) {
        const base64String = new Buffer(data, contentType).toString('base64')
        const byteString = atob(base64String);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], {type: contentType});
        return blob
    }

    return {
        convertToBlob: _convertToBlob
    }

})();

export default DocumentService;